import { API_ROOT_URL } from '../constants/'

export function maskFromPreview (preview, format) {
  if (!preview || typeof preview !== 'object') return ''
  const { first4, last4, length } = preview
  if (length == null || length === 0) return ''
  if (first4 === '' && last4 === '') {
    return '*'.repeat(length)
  }
  switch (format) {
    case 'first4-stars-last4':
      return first4 + '*'.repeat(length - 8) + last4
    case 'stars-last4':
      return '*'.repeat(length - 4) + last4
    case 'first4-16stars-last4':
      return first4 + '*'.repeat(16) + last4
    default:
      return ''
  }
}

export async function revealCredential ({ kind, id, field, getToken }) {
  const token = await getToken()
  const response = await fetch(`${API_ROOT_URL}/api_fs/${kind}/${id}/reveal`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ field }),
  })
  if (!response.ok) {
    throw new Error('REVEAL_FAILED')
  }
  const payload = await response.json()
  return payload.value
}

export async function copyRevealedCredential (args, copy) {
  try {
    const value = await revealCredential(args)
    copy(value)
  } catch (_error) {
    // Never copy when reveal fails.
  }
}
